export default __webpack_public_path__ + "resources/icons/n100-b583.png";